
import urlencode from "urlencode";
import { eventBus } from "@/utils/EventBus";

export function portalLogin () {
    eventBus.$emit('show-login', false);
}

export function login () {
    let params = urlencode(window.location.href)
    let url = process.env.VUE_APP_LOGINURL.replace('xxxxxxxxxxx', params)
    window.open(url, "_self");
}

export function getnewurl (name) {
    var query = window.location.search.substr(1);
    if (query.indexOf(name) > -1) {
        var obj = {}
        var arr = query.split("&");
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split("=");
            obj[arr[i][0]] = arr[i][1];
        };
        return obj
    };
}
